import React, { Component } from "react";
import { Panel, Col, Glyphicon } from "react-bootstrap";
import AscModal from "../Elements/Modal/Modal";
import InlineForm from "../Elements/FromGroup/InlineForm";
import MultiSelect from "../Elements/Select/MultiSelect";
import "../Elements/FromGroup/form_select.css";
import * as GlobalConst from "../../components/AscConstants";

export default class OperatorGroupModal extends Component {
    getOperatorGroupItems = () => {
        let {
            state,
            propSetState,
            langText,
            charaLimit,
            onTextChange_Limit,
            onSelectChange,
            validationHandle,
            getScopeGreaterEqual,
            checkOperatorGroupNameDuplicate
        } = this.props;
        let itemArr = [];

        // 会社
        if (
            getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem) &&
            (state.modalType === "insert" || state.modalType === "copy")
        ) {
            itemArr.push(
                <InlineForm
                    key="company_id"
                    controlId="company_id"
                    label={langText.Body.CompanyName}
                    type="select"
                    value={state.company_id}
                    onChange={e => onSelectChange(e, "company_id")}
                    options={state.companySelect}
                    isClearable={true}
                    validationState={validationHandle("company_id")}
                    placeholder={langText.SelectOption.Placeholder}
                />
            );
        } else {
            itemArr.push(
                <InlineForm.static
                    key="company_id"
                    controlId="company_id"
                    label={langText.Body.CompanyName}
                >
                    {state.company_name}
                </InlineForm.static>
            );
        }

        // 拠点 or フロア
        if (
            getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.company) 
            && (state.modalType === "insert" || state.modalType === "copy")
        ) {
            itemArr.push(
                <InlineForm
                    key="department_id"
                    controlId="department_id"
                    label={langText.Body.DepartmentName}
                    type="select"
                    value={state.department_id}
                    onChange={e => onSelectChange(e, "department_id")}
                    options={state.departmentSelect}
                    isClearable={true}
                    validationState={validationHandle("department_id")}
                    placeholder={langText.SelectOption.Placeholder}
                    isDisabled={!state.company_id}
                />
            );
        } else {
            itemArr.push(
                <InlineForm.static
                    key="department_id"
                    controlId="department_id"
                    label={langText.Body.DepartmentName}
                >
                    {state.department_name}
                </InlineForm.static>
            );
        }

        if (this.props.state.floor_flg) {
            if (
                getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.department) 
                && (state.modalType === "insert" || state.modalType === "copy")
            ) {
                itemArr.push(
                    <InlineForm
                        key="floor_id"
                        controlId="floor_id"
                        label={langText.Body.FloorName}
                        type="select"
                        options={state.floorSelect}
                        value={state.floor_id}
                        onChange={e => onSelectChange(e, "floor_id")}
                        isClearable={true}
                        validationState={validationHandle("floor_id")}
                        placeholder={langText.SelectOption.Placeholder}
                        isDisabled={!state.department_id}
                    />
                );
            } else {
                itemArr.push(
                    <InlineForm.static
                        key="floor_id"
                        controlId="floor_id"
                        label={langText.Body.FloorName}
                    >
                        {state.floor_name}
                    </InlineForm.static>
                );
            }
        }

        // グループ名
        if (state.modalType === "insert" || state.modalType === "update" || state.modalType === "copy") {
            itemArr.push(
                <InlineForm
                    key="group_name"
                    controlId="group_name"
                    label={langText.Body.GroupName}
                    type="text"
                    value={state.group_name}
                    onChange={e => onTextChange_Limit(e, "group_name", charaLimit.InboundG_group_name)}
                    onBlur={() => checkOperatorGroupNameDuplicate()}
                    validationState={validationHandle("group_name")}
                />
            );
            if (state.operatorGroupNameDuplicateFlag) {
                itemArr.push(
                    <p key="operatorGroupNameDuplicate" className="text-danger">
                        {langText.Body.OperatorGroupNameDuplicate}
                    </p>
                );
            }
        } else {
            itemArr.push(
                <InlineForm.static
                    key="group_name"
                    controlId="group_name"
                    label={langText.Body.GroupName}
                >
                    {state.group_name}
                </InlineForm.static>
            );
        }

        // オペレーター割当
        itemArr.push(
            <InlineForm label={langText.MultiSelect.OperatorSelect} validationState={validationHandle("operator_ids")} key="operator_ids">
                <MultiSelect
                    controlId="operator_ids"
                    propSetState={propSetState}
                    multiSelectText={langText.MultiSelect}
                    searchText={langText.MultiSelect.OperatorSearch}
                    options={state.operatorSelect}
                    value={state.operator_ids}
                    type={state.modalType}
                    isDisabled={state.modalType === "delete" || state.modalType === "read"}
                    multiSelectMessage={langText.MultiSelect.SelectDataOperatorStr_NDelete}
                    multiSelectDeleteMessage={langText.MultiSelect.SelectDataOperatorStr_Delete}
                />
            </InlineForm>
        );

        return itemArr;
    }

    render() {
        return (
            <AscModal
                state={this.props.state}
                propSetState={this.props.propSetState}
                langText={this.props.langText}
                validationHandle={this.props.validationHandle}
                onClick={this.props.onClick}
            >
                <Panel bsStyle="info">
                    <Panel.Heading>
                        <Panel.Title>
                            {this.props.langText.Body.GroupName}
                        </Panel.Title>
                    </Panel.Heading>
                    <Panel.Body>
                        {this.getOperatorGroupItems()}
                    </Panel.Body>
                </Panel>
            </AscModal>
        );
    }
}


